import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createStation: [],
    loading: false,
    error: null,
}

const createStationSlice = createSlice({
    name: "createStation",
    initialState,
    reducers: {
        fetchCreateStationSuccess: (state, action) => {
            state.loading = false,
            state.createStation = action.payload;
        },
        fetchCreateStationFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetchCreateStationSuccess,
    fetchCreateStationFailure,
} = createStationSlice.actions;

export default createStationSlice.reducer;